import { AccessList } from "../pages/admin-panel/users/types";

export const ALL_ACCESS: AccessList = [
  "ReceiveCheque",
  "ConfirmCheque",
  "DeliverCheque",
  "SpendCheque",
  "ReceiveCash",
  "SpendCash",
  "EditCash",
  "AddEditCustomer",
  "EditFactorCheque",
  "Admin",
];

export const ACCESS_FA = [
  "دریافت چک",
  "تایید چک",
  "تحویل چک",
  "خرج چک",
  "دریافت پول نقد",
  "خرج پول نقد",
  "ویرایش پول نقد",
  "افزودن/ویرایش مشتری",
  "ویرایش فاکتور/چک",
  "مدیر",
];
